import { tokenMatcher, } from 'chevrotain';
import { isCstNode } from 'helpers/chevrotain/cst';
var stardogGraphQlTokenMap = require('./tokens').stardogGraphQlTokenMap;
var _a = stardogGraphQlTokenMap, ToArgumentToken = _a.ToArgumentToken, IfArgumentToken = _a.IfArgumentToken, AliasArgumentToken = _a.AliasArgumentToken, GraphArgumentToken = _a.GraphArgumentToken, BindDirectiveToken = _a.BindDirectiveToken, ConfigDirectiveToken = _a.ConfigDirectiveToken, SkipDirectiveToken = _a.SkipDirectiveToken, IncludeDirectiveToken = _a.IncludeDirectiveToken, FilterDirectiveToken = _a.FilterDirectiveToken;
var conditionalDirectiveTokens = [
    SkipDirectiveToken,
    IncludeDirectiveToken,
    FilterDirectiveToken,
];
var sparqlReceivingStardogDirectiveTokens = [
    BindDirectiveToken
].concat(conditionalDirectiveTokens);
function getArgumentTokenTypesForDirectiveNameToken(directiveNameToken) {
    if (tokenMatcher(directiveNameToken, BindDirectiveToken)) {
        return [ToArgumentToken];
    }
    else if (tokenMatcher(directiveNameToken, ConfigDirectiveToken)) {
        return [AliasArgumentToken, GraphArgumentToken];
    }
    else if (conditionalDirectiveTokens.some(function (tokenType) {
        return tokenMatcher(directiveNameToken, tokenType);
    })) {
        return [IfArgumentToken];
    }
    else {
        return [];
    }
}
function getArgumentNodes(argumentDictionary) {
    if (!argumentDictionary || !argumentDictionary.Arguments) {
        return [];
    }
    var argumentsNode = argumentDictionary.Arguments[0];
    if (!isCstNode(argumentsNode)) {
        return [];
    }
    return argumentsNode.children.Argument || []; // this should be an array of all 'Argument' nodes
}
function isSparqlReceivingStardogDirective(directiveToken) {
    return sparqlReceivingStardogDirectiveTokens.some(function (tokenType) {
        return tokenMatcher(directiveToken, tokenType);
    });
}
export var graphQlUtils = {
    getArgumentNodes: getArgumentNodes,
    getArgumentTokenTypesForDirectiveNameToken: getArgumentTokenTypesForDirectiveNameToken,
    isSparqlReceivingStardogDirective: isSparqlReceivingStardogDirective,
};
